import React, { useCallback, useState } from "react";
import "./enterprise-faq.css";

/**
 * FAQ accesible (teclado + ARIA) para SEO/UX enterprise; sin dependencias extra.
 */
function EnterpriseFaqSection({
  id: idProp,
  eyebrow = "Preguntas frecuentes",
  title = "Resolvemos lo esencial antes del primer contacto",
  intro = null,
  items,
  className = "",
}) {
  const baseId = idProp || "gk-faq";
  const [openIndex, setOpenIndex] = useState(0);

  const toggle = useCallback((index) => {
    setOpenIndex((prev) => (prev === index ? -1 : index));
  }, []);

  if (!items || !items.length) return null;

  return (
    <section
      className={`gk-faq sec-mar ${className}`.trim()}
      aria-labelledby={`${baseId}-heading`}
    >
      <div className="container">
        <div className="title-wrap">
          <div className="sec-title text-center layout2">
            {eyebrow ? <span>{eyebrow}</span> : null}
            <h2 id={`${baseId}-heading`}>{title}</h2>
            {intro ? <p className="gk-faq__intro">{intro}</p> : null}
          </div>
        </div>
        <div className="gk-faq__list" role="list">
          {items.map((item, index) => {
            const panelId = `${baseId}-panel-${index}`;
            const buttonId = `${baseId}-trigger-${index}`;
            const expanded = openIndex === index;
            return (
              <div key={item.question} className="gk-faq__item" role="listitem">
                <h3 className="gk-faq__question">
                  <button
                    type="button"
                    id={buttonId}
                    className="gk-faq__trigger"
                    aria-expanded={expanded}
                    aria-controls={panelId}
                    onClick={() => toggle(index)}
                  >
                    <span className="gk-faq__trigger-text">{item.question}</span>
                    <span className="gk-faq__icon" aria-hidden="true">
                      {expanded ? "−" : "+"}
                    </span>
                  </button>
                </h3>
                <div
                  id={panelId}
                  role="region"
                  aria-labelledby={buttonId}
                  className={`gk-faq__panel${expanded ? " is-open" : ""}`}
                  hidden={!expanded}
                >
                  <p className="gk-faq__answer">{item.answer}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default EnterpriseFaqSection;
